import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { RiskMatrixActions } from '@client/components/risks/RiskMatrixActions';
import { RiskMatrixContextProvider } from '@client/components/risks/risk-matrix/RiskMatrixContext';
import { createFileRoute, useMatch } from '@tanstack/react-router';
import { AlertCircle } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/risk')({
    staticData: {
        ui: {
            icon: AlertCircle,
            title: 'Risk configuration',
            subtitle: 'Configure risk appetite and categories',
            useTitleForChildren: true,
            menuDescription: 'Configure risk appetite and categories',
        },
        breadcrumb: {
            title: 'Risk',
            inactive: true,
        },
        modules: ['risk'],
        permissions: ['settings:update'],
    },
    component: ConfigurationRisk,
});

function ConfigurationRisk() {
    const matrixMatch = useMatch({ from: '/console/$orgId/configuration/risk/matrix', shouldThrow: false });

    return (
        <PageController route={Route}>
            <RiskMatrixContextProvider>
                <Tabs
                    items={[
                        {
                            label: 'Risk appetite',
                            to: '/console/$orgId/configuration/risk/appetite',
                        },
                        {
                            label: 'Risk categories',
                            to: '/console/$orgId/configuration/risk/categories',
                        },
                        {
                            label: 'Risk matrix',
                            to: '/console/$orgId/configuration/risk/matrix',
                        },
                    ]}
                    rightAddon={matrixMatch ? <RiskMatrixActions /> : null}
                />
            </RiskMatrixContextProvider>
        </PageController>
    );
}
